<template>
    <div class="creator--listing" style="height:100%;">
        <creator-header v-if="plugin && versions" :plugin="plugin" :versions="versions"></creator-header>
        <placeholder v-else :type="'creator.header'"></placeholder>
        <div v-if="plugin && versions" class="container">
            <div class="creator">
                <creator-navigation :id="plugin_id"></creator-navigation>
                <div class="right">
                    <div class="plugin__header">
                        <h2>{{$t('page.listing.listing')}}</h2>
                    </div>
                    <div>
                        <div class="listing__category">
                            <div class="listing__category--entry">
                                <label class="label" for="title">{{$t('page.listing.title')}}<sup>*</sup></label>
                                <input v-model="plugin.name" class="input--text" type="text" id="title" name="title">
                            </div>
                        </div>
                        <div class="listing__category">
                            <h3>{{$t('page.listing.description')}}</h3>
                            <div class="tab__wrapper">
                                <div v-if="false" class="tab__content--top">
                                    <ul>
                                        <template v-for="tab in tabs" :key="tab.id">
                                            <li @click="toggleTab(tab)" :class="getTabClass(tab)" v-if="tab.active">
                                                {{tab.label}}
                                            </li>
                                        </template>
                                        <select @change="languageChange($event)" v-if="tabSelectorVisible" class="tab__selector">
                                            <option selected="selected" disabled="disabled">{{$t('action.please_choose')}}</option>
                                            <template v-for="tab in tabs" :key="tab.id">
                                                <option :value="tab.code" v-if="!tab.active">
                                                    {{tab.label}}
                                                </option>
                                            </template>
                                        </select>
                                        <li @click="toggleTabSelector()" class="tab--add">
                                            <span>&nbsp;</span>
                                            <span>&nbsp;</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab__content--bottom">
                                    <template v-for="tab in tabs" :key="tab.id">
                                        <div v-if="tab.selected" class="tab__entry">
                                        <div class="listing__category--entry">
                                            <label class="label" for="short_description">{{$t('page.listing.short_desc')}}<sup>*</sup></label>
                                            <textarea v-model="tab.short_desc" id="short_description" name="short_description" rows="2" maxlength="200" class="input--textarea"></textarea>
                                            <span class="input--info">{{length(tab.short_desc)}} / 200</span>
                                        </div>
                                        <div class="listing__category--entry">
                                            <label class="label" for="description">{{$t('page.listing.desc')}}<span class="description">{{$t('page.listing.desc_text')}}</span></label>
                                            <vue-editor id="description" name="description" v-model="tab.description" :editor-toolbar="customToolbar" class="input--editor"></vue-editor>
                                        </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="listing__category">
                            <h3>{{$t('page.listing.image')}}</h3>
                            <div class="listing__category--entry">
                                <div @click="toggleRadio('icon')" class="input--radio">
                                    <input v-if="(icon_type == 'image')" type="radio" id="custom" name="icon" value="custom">
                                    <span v-else class="checkbox--fake radio"><div class="bullet">&nbsp;</div></span>
                                    <label for="custom">{{$t('page.listing.icon_custom')}}</label><br/>
                                </div>
                                <div @click="toggleRadio('image')" class="input--radio">
                                    <input v-if="(icon_type != 'image' )" type="radio" id="upload" name="icon" value="upload">
                                    <span v-else class="checkbox--fake radio"><div class="bullet">&nbsp;</div></span>
                                    <label for="upload">{{$t('page.listing.image_upload')}}<span class="description">{{$t('page.listing.image_upload_text')}}</span></label>
                                </div>
                                <div class="preview--box">
                                    <plugin-logo :size="128" :type="plugin.image.type" :path="plugin.image.path"></plugin-logo>
                                    <div class="preview--edit">
                                        <btn @click="toggleWrapper" :class="'btn--ghost'" :text="$t('page.listing.icon_btn')" />
                                        <div v-if="showWrapper && (icon_type != 'image')" class="icon__wrapper">
                                            <div @click="changeImage('icon', icon)" v-for="icon in availableIcons" :key="icon" class="icon__wrapper--entry">
                                                <img width="24" height="24" :src='"https://api.library.loxone.com/files/global/icons/black/" + icon' />
                                            </div>
                                        </div>
                                        <div v-if="showWrapper && (icon_type == 'image')" class="image__wrapper">
                                            <label for="logo" class="background">
                                                <label for="logo" class="button">{{$t('page.creator.upload_select')}}</label>
                                            </label>
                                            <input accept="image/*" @change="changeImage('image', 'logo')" type="file" id="logo" name="logo" ref="logo" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="listing__category">
                            <h3>Additional Downloads</h3>
                            <div>
                                <div v-if="plugin.attachments && plugin.attachments.length > 0">
                                    <file-list @remove-attachment="removeAttachment" :files="plugin.attachments" :remove="true" :download="true"></file-list>
                                </div>
                                <div>
                                    <label style="vertical-align:bottom;" for="config" class="btn btn--ghost btn--no-offset-left">{{$t('page.creator.upload_select')}}</label>
                                    <input style="display:none;" @change="uploadConfig()" type="file" id="config" name="config" ref="config" multiple/>
                                </div>
                            </div>
                        </div>
                        <div class="listing__category">
                            <h3>{{ $t('page.listing.additional_info') }}</h3>
                            <div class="listing__category--entry">
                                <label class="label">
                                    {{$t('page.listing.cat')}}<sup>*</sup>
                                    <span class="description">{{$t('page.listing.cat_text')}}</span>
                                </label>
                                <tag-cloud @remove-entry="removeCategory" @add-entry="addCategory" :key="'category'" :keywords="plugin.categories" :staticEntries="true" :entries="categories"></tag-cloud>
                            </div>
                            <dropdown :validator="validator.drp_technology" v-if="plugin.type != 'addon' && technologies" @update-meta="updateMetaValue" :object="plugin.technologies" :list="technologies" :title="'Technology'"></dropdown>
                            <brand-dropdown :validator="validator.drp_brand" v-if="brands" @update-meta="updateBrand" :object="plugin.brands" :list="brands" :title="$t('page.listing.brand')"></brand-dropdown>
                            <template v-if="plugin.type != 'addon'">
                                <label class="label" for="config_version">{{$t('page.listing.config_version')}}</label>
                                <input v-model="plugin.config_version" class="input--text" type="text" id="config_version" name="config_version">
                            </template>
                            <div class="listing__category--entry">
                                <label class="label" for="device">{{$t('page.listing.supported_devices')}}<span class="description">{{$t('page.listing.supported_device_text')}}</span></label>
                                <tag-cloud @remove-entry="removeDevice" @add-entry="addDevice" :key="'device'" :keywords="devicesArr"></tag-cloud>
                            </div>
                            <div class="listing__category--entry">
                                <label class="label" for="keywords">{{$t('page.listing.keywords')}}<span class="description">{{$t('page.listing.keywords_text')}}</span></label>
                                <tag-cloud @remove-entry="removeKeyword" @add-entry="addKeyword" :key="'keywords'" :keywords="keywordsArr"></tag-cloud>
                            </div>
                            <div v-if="plugin.type != 'addon'" class="listing__category--entry">
                                <div class="listing__category--entry">
                                    <label class="label" for="works with Loxone">works with Loxone</label>
                                    <div @click="toggleSelected">
                                        <input v-if="!plugin.certified" type="checkbox" />
                                        <span v-else class="checkbox--fake checkbox--input">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24">
                                                <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF"></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="listing__category--entry">
                                    <label class="label" for="button_text">Button Text</label>
                                    <input v-model="plugin.button_text" class="input--text" type="text" id="button_text" name="button_text">
                                </div>
                                
                                <div class="listing__category--entry">
                                    <label class="label" for="button_url">Button Link</label>
                                    <input v-model="plugin.button_url" class="input--text" type="text" id="button_url" name="button_url">
                                </div>
                            </div>
                        </div>
                        <div v-if="faqs == 'not_available'" class="listing__category">
                            <div class="listing__category--header">
                                <h3>{{$t('page.listing.faq')}}</h3>
                                <btn @click="addFaq()" :class="'btn--ghost'" :text="$t('page.listing.add_question')" />
                            </div>
                            <div v-if="faqs.length > 1">
                                <draggable 
                                    v-model="faqs" 
                                    @start="drag=true"
                                    @update="onDraggableUpdate"
                                    @end="drag=false" 
                                    item-key="id">
                                    <template #item="{element}">
                                        <new-faq @save-faq="saveFaq" @delete-faq="deleteFaq" :faq="element"></new-faq>
                                    </template>
                                </draggable>
                            </div>
                            <div v-else>
                                <new-faq @save-faq="saveFaq" @delete-faq="deleteFaq" v-for="faq in faqs" :key="faq.id" :faq="faq"></new-faq>
                            </div>
                        </div>
                    </div>
                    <btn @click="savePlugin()" :class="'btn--save'" :text="$t('page.listing.save')" />
                </div>
            </div>
        </div>
        <placeholder v-else :type="'page.creator_listing'"></placeholder>
    </div>
</template>



<script>
    import axios from 'axios';
    import PluginLogo from '@/components/PluginLogo.vue';
    import TagCloud from '@/components/TagCloud.vue';
    import NewFaq from '@/components/NewFaq.vue';
    import { VueEditor } from "vue3-editor";
    import draggable from 'vuedraggable'
    import CreatorNavigation from '@/components/CreatorNavigation.vue';
    import CreatorHeader from '@/components/CreatorHeader.vue';
    import Dropdown from '@/components/Dropdown.vue';
    import BrandDropdown from '@/components/BrandDropdown.vue';
    import FileList from '@/components/FileList.vue';
    import Placeholder from '@/components/Placeholder.vue';
    import Btn from '@/components/Button.vue';

export default{
    components: {
        PluginLogo,
        TagCloud,
        NewFaq,
        VueEditor,
        draggable,
        CreatorNavigation,
        CreatorHeader,
        Dropdown,
        BrandDropdown,
        FileList,
        Placeholder,
        Btn
    },

    data() {
        return {
            plugin: null,
            short_description: null,
            showWrapper: false,
            versions: null,
            description: null,
            icon_type: "icon",
            logo: null,
            upload: "",
            devices: null,
            brand: null,
            keywordsArr: [],
            devicesArr: [],
            productsArr: [],
            customToolbar : [
                [
                    { header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{list: "ordered"}, {list: "bullet"}],
                ["blockquote", "code-block"],
                ["link", "image", "video"],
                ["clean"]
            ],
            faqs: [],
            categories: null,
            products: null,
            technologies: null,
            brands: null,
            newFaqResult: null,
            editLanguage: this.$i18n.locale,
            plugin_id: window.location.href.split('/')[5].substring(window.location.href.split('/')[5].lastIndexOf('-') + 1),
            tabSelectorVisible: false,
            tabs: {
                en_gb: {
                    label:        this.$t('languages.en_gb'),
                    code:         'en_gb',
                    mandatory:    true,
                    selected:     true,
                    active:       true,
                    short_desc:   '',
                    description:  ''
                },
            },
            validator: {
                txt_title: {
                    error: false,
                    message: '',
                },
                drp_category: {
                    error: false,
                    message: '',
                },
                drp_technology: {
                    error: false,
                    message: '',
                },
                drp_brand: {
                    error: false,
                    message: '',
                },
                cld_devices: {
                    error: false,
                    message: '',
                }
            }
        }
    },

    methods: {

        toggleSelected() {
            this.plugin.certified = !this.plugin.certified;
        },
         
        updateBrand(value) {
            console.error(value);
            this.plugin.brands.new_value = value;
        },

        toggleTab(tab) {
            for (const [key, value] of Object.entries(this.tabs)) {
                value.selected = false;
                if(key == tab.code) {
                    value.selected = true;
                }
            }
        },

        languageChange(event) {
            /*for (const [key, value] of Object.entries(this.tabs)) {
                value.selected = false;
                if(key == event.target.value) {
                    value.active = true;
                    value.selected = true;
                    this.tabSelectorVisible = false;
                }
            }*/
        },

        toggleTabSelector() {
            this.tabSelectorVisible = true;
        },

        getTabClass(tab) {
            var className = "";

            className = 'tab';

            if(tab.mandatory) {
                className += ' mandatory';
            }

            if(tab.selected) {
                className += ' active';
            }

            return className;
        },

        toggleWrapper() {
            this.showWrapper = !this.showWrapper;
        },

        beautifyRating(rating) {
            return (rating/100)*100;
        },

        saveFaq(question, answer, id) {
            for (const [faq_key, faq_value] of Object.entries(this.faqs)) {
                if(faq_value.id == id) {
                    faq_value.question = question;
                    faq_value.answer = answer;

                    
                    var pluginInfo = new FormData();
                    pluginInfo.append('plugin', this.plugin_id);
                    pluginInfo.append('id', id);
                    pluginInfo.append('question', question);
                    pluginInfo.append('answer', answer);
                    
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        url: 'https://api.library.loxone.com/updateFaq',
                        data: pluginInfo,
                    }).then(response => {
                        this.response = response.data;
                        if(this.response.success){
                            this.$store.dispatch('addNotification', {title: 'FAQ gespeichert', text: 'Das FAQ element wurde gespeichert.', type: 'success'});
                        }else{
                            this.$store.dispatch('addNotification', {title: 'Fehler', text: 'Ein Fehler ist aufgetereten.', type: 'error'});
                        }
                    });
                }
            }
        },

        deleteFaq(id) {
            for (const [faq_key, faq_value] of Object.entries(this.faqs)) {
                if(faq_value.id == id) {
                        var pluginInfo = new FormData();
                        pluginInfo.append('plugin', this.plugin_id);
                        pluginInfo.append('id', id);
                    axios({
                        method: 'post',
                        crossDomain: true,
                        withCredentials: true,
                        url: 'https://api.library.loxone.com/deleteFaq',
                        data: pluginInfo,
                    }).then(response => {
                        this.response = response.data;
                        if(this.response.success){
                            this.faqs.splice(faq_key,1);
                            this.$store.dispatch('addNotification', {title: 'FAQ gelöscht', text: 'Das FAQ element wurde gelöscht.', type: 'success'});
                        }else{
                            this.$store.dispatch('addNotification', {title: 'Fehler', text: 'Ein Fehler ist aufgetereten.', type: 'error'});
                        }
                    });
                }
            }
        },

        addFaq() {
            var pluginInfo = new FormData();
            pluginInfo.append('plugin', this.plugin_id);

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/addFaq',
                data: pluginInfo,
            }).then(response => {
                this.response = response.data;
                if(this.response.success){
                    this.faqs.push({
                        'id':			this.response.id,
                        'faq_sorting':	this.response.sorting,
                        'question':		'',
                        'answer':		'',
                    });
                }
            });
        },

        addKeyword(text) {
            if (this.keywordsArr.indexOf(text) === -1) {
                this.keywordsArr.push(text);
            }
        },

        removeKeyword(text) {
            var index = this.keywordsArr.indexOf(text);

            if (index > -1) {
                this.keywordsArr.splice(index, 1);
            }
        },

        addDevice(text) {
            if (this.devicesArr.indexOf(text) === -1) {
                this.devicesArr.push(text);
            }
        },

        removeDevice(text) {
            var index = this.devicesArr.indexOf(text);

            if (index > -1) {
                this.devicesArr.splice(index, 1);
            }
        },

        addCategory(entry) {
            if(entry) {
                delete this.categories[entry.id];
                this.plugin.categories[entry.id] = entry;
            }
        },

        removeCategory(entry) {
            delete this.plugin.categories[entry.id];
            this.categories[entry.id] = entry;
        },

        upload_val() {
            if(this.icon_type == 'custom') {
                return "";
            }
            return this.upload;
        },

        toggleRadio(data) {
            this.icon_type = data;
        },

        length(string) {
            if(string) {
                return string.length;
            }
            return 0;
        },

        getDate(date) {
            var dateVar = new Date(date);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };

            return dateVar.toLocaleDateString('de-DE', options);
        },

        onDraggableUpdate() {
            var orderElement = [];
            for (const [key, value] of Object.entries(this.faqs)) {
                orderElement.push(value.id);
            }

            orderElement;

            var pluginInfo = new FormData();
            pluginInfo.append('order', orderElement);
            pluginInfo.append('action', 'reorder');

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/updateFaq',
                data: pluginInfo,
            }).then(response => {
                this.response = response.data;
                if(this.response.success){
                    this.$store.dispatch('addNotification', {title: this.$t('notification.faq_sorting_update_successfull'), text: this.$t('notification.faq_sorting_update_successfull_txt'), type: 'success'});
                }else{
                    this.$store.dispatch('addNotification', {title: this.$t('notification.faq_sorting_update_failed'), text: this.$t('notification.faq_sorting_update_failed_txt'), type: 'error'});
                }
            });
        },

        savePlugin() {
            var result = this.checkBeforeSave();
            if(result.success) {
                var pluginInfo = new FormData();
                pluginInfo.append('plugin', JSON.stringify(this.plugin));
                pluginInfo.append('keywords', this.keywordsArr);
                pluginInfo.append('devices', this.devicesArr);
                pluginInfo.append('lang', this.editLanguage);
                pluginInfo.append('translations', JSON.stringify(this.tabs));
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/updatePluginMeta',
                    data: pluginInfo,
                }).then(response => {
                    this.plugin.brands.value = this.plugin.brands.new_value;
                    if(response.data.valid) {
                        this.$store.dispatch('addNotification', {title: this.$t('notification.plugin_listing_update_successfull'), text: this.$t('notification.plugin_listing_update_successfull_txt'), type: 'success'});
                    } else {
                        this.$store.dispatch('addNotification', {title: this.$t('notification.plugin_listing_update_failed'), text: this.$t('notification.plugin_listing_update_failed_txt'), type: 'error'});
                    }
                });
            }else{
                this.$store.dispatch('addNotification', {title: this.$t('notification.plugin_listing_update_check_failed'), text: result.error, type: 'error'});
            }
        },

        checkBeforeSave() {
            var result = {
                success: true,
                error: ''
            };
            
            /* Check Title */
            if(this.plugin.name.length == '' || this.plugin.name.length == null) {
                result = {
                    success: false,
                    error: this.$t('page.listing.update.error.field_empty', {field: this.$t('page.listing.title')})
                }
            }else if(this.plugin.name.length < 3) {
                result = {
                    success: false,
                    error: this.$t('page.listing.update.error.field_to_short', {field: this.$t('page.listing.title'), length: 3})
                }
            }

            /* Check English Short Description */
            if(result.success) {
                if(this.tabs.en_gb.short_desc.length == '' || this.tabs.en_gb.short_desc.length == null) {
                    result = {
                        success: false,
                        error: this.$t('page.listing.update.error.field_empty', {field: this.$t('page.listing.short_desc')})
                    }
                }else if (this.tabs.en_gb.short_desc.length < 30) {
                    result = {
                        success: false,
                        error: this.$t('page.listing.update.error.field_to_short', {field: this.$t('page.listing.short_desc'), length: 30})

                    }
                }else if (this.tabs.en_gb.short_desc.length > 200) {
                    result = {
                        success: false,
                        error: this.$t('page.listing.update.error.field_to_long', {field: this.$t('page.listing.short_desc'), length: 200})

                    }
                }

                /* Check Image / Icon */
                if(result.success) {
                    if(this.plugin.image.type == 'image' && (this.plugin.image.path == '' || this.plugin.image.path == null)) {
                        result = {
                            success: false,
                            error: this.$t('page.listing.update.error.missing_image')
                        }
                    } else if(this.plugin.image.type == 'icon' && (this.plugin.image.path == '' || this.plugin.image.path == null)) {
                        result = {
                            success: false,
                            error: this.$t('page.listing.update.error.missing_icon')
                        }
                    }

                    /* Check Category*/
                    if(result.success) {
                        if(Object.keys(this.plugin.categories) < 1) {
                            result = {
                                success: false,
                                error: this.$t('page.listing.update.error.missing_category')
                            }
                        }

                        /* Check Technology */
                        if(result.success) {
                            if(this.plugin.technologies.id == '' && this.plugin.type != 'plugin') {
                                result = {
                                    success: false,
                                    error: this.$t('page.listing.update.error.missing_technology')
                                }
                            }

                            /* Check Brand */
                            if(result.success) {
                                if(this.plugin.brands.new_value == "" && this.plugin.type != 'plugin') {
                                    result = {
                                        success: false,
                                        error: this.$t('page.listing.update.error.missing_brand')
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return result;
        },

        updateMetaValue(obj, event) {
            obj.id = event.target.value;
        },

        updateEditingLang(event) {
            this.editLanguage = event;
            this.setCookie('library_edit_lang', this.editLanguage, 365);
            var pluginInfo = new FormData();
            pluginInfo.append('plugin', this.plugin_id);
            pluginInfo.append('lang', this.editLanguage);
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadPluginDetail',
                data: pluginInfo,
            }).then(response => {
                this.plugin.short_description = response.data.short_description;
                this.plugin.description = response.data.description;
            });
        },

        setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=loxone.com;path=/";
        },

        uploadConfig() {
            var pluginInfo = new FormData();
            pluginInfo.append('plugin_id', this.plugin_id);
            pluginInfo.append('full_id', this.plugin.id);
            for( var i = 0; i < this.$refs.config.files.length; i++ ){
                let file = this.$refs.config.files[i];
                pluginInfo.append('files[' + i + ']', file);
            }

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/uploadPluginAttachments',
                data: pluginInfo,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                if(response.data.files) {
                    for (let i=0; i < response.data.files.length; i++) {
                        console.log(response.data.files[i]);
                        this.plugin.attachments.push(response.data.files[i]);
                    }
                }
            });
        },

        removeAttachment(name) {
            var pluginInfo = new FormData();
            pluginInfo.append('full_id', this.plugin.id);
            pluginInfo.append('plugin_id', this.plugin_id);
            pluginInfo.append('name', name);
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/removeAttachment',
                data: pluginInfo,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                this.plugin.attachments = response.data.attachments;
            });
        },

        changeImage(type, name) {
            var pluginInfo = new FormData();
                pluginInfo.append('plugin_id', this.plugin_id);
                pluginInfo.append('type', type);

            if(type == 'image') {
                pluginInfo.append('full_id', this.plugin.id);
                for( var i = 0; i < this.$refs.logo.files.length; i++ ){
                    let file = this.$refs.logo.files[i];
                    pluginInfo.append('files[' + i + ']', file);
                }
            } else {
                pluginInfo.append('name', name);
            }
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/updatePluginLogo',
                    data: pluginInfo,
                }).then(response => {
                    this.plugin.image.type = type;
                    this.plugin.image.path = response.data.name;
                });
            this.showWrapper = false;
        }
    },

    created() {
        this.editLanguage = getCookie('library_edit_lang');
        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadCategories',
            data: pluginInfo,
        }).then(response => (this.categories = response.data));

        
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadTechnologies',
            data: pluginInfo,
        }).then(response => (this.technologies = response.data));

        var pluginInfo = new FormData();
        pluginInfo.append('plugin', this.plugin_id);
        pluginInfo.append('lang', this.editLanguage);
        pluginInfo.append('plugin_id', this.plugin_id);
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadPluginDetail',
            data: pluginInfo,
        }).then(response => {
            this.plugin = response.data;
            if(response.data.image && response.data.image.type) {
                this.icon_type = response.data.image.type;
            }

            if(this.categories && Object.entries(this.categories).length > 0) {
                for( const[key, value] of Object.entries(this.plugin.categories)) {
                    delete this.categories[key];
                }
            }
        });

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadTranslations',
            data: pluginInfo,
        }).then(response => {
            for (const [key, value] of Object.entries(response.data)) {

                for (const [sub_key, sub_value] of Object.entries(this.tabs)) {
                    if(key == sub_key) {
                        sub_value.short_desc = value.short_description;
                        sub_value.description = value.description;
                        sub_value.active = true;
                    }
                }
            }

        });
        
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadDevices',
            data: pluginInfo,
        }).then(response => {
            if(response.data.length > 1 || response.data != "") {
                this.devicesArr = response.data;
            }
        });
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadBrands',
            data: pluginInfo,
        }).then(response => (this.brands = response.data));

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadKeywords',
            data: pluginInfo,
        }).then(response => {
            if(response.data.length > 1 || response.data != "") {
                this.keywordsArr = response.data;
            }
        });

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadPluginIcons',
        }).then(response => {
            this.availableIcons = response.data;
        });

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadPluginVersions',
            data: pluginInfo,
        }).then(response => {
            this.versions = response.data
        });

        /*axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadFaqs',
            data: pluginInfo,
        }).then(response => (this.faqs = response.data));*/
    },
}
</script>

<style scoped lang="scss">
    @import '../scss/utilities/variables';
    @import '../scss/pages/creator';

    .example__file--handler{
        display: flex;
        justify-content: flex-start;
        margin-top: 10px;
        cursor: pointer;

        > div {
            margin-left: 10px;
            position: relative;
            width: 30px;
            height: 30px;

            span{
                display: inline-block;
                height: 2px;
                background-color: black;
                width: 24px;
                position: absolute;
                top: 11px;
                left: 0;
                right: 0;
                bottom: 0;

                &:first-child {
                    transform: rotate(-45deg);
                }

                &:last-child {
                    transform: rotate(45deg);
                }
            }
        }
    }

    input[type="checkbox"] {
            width: 24px;
            height: 24px;
            border-radius: 0;
            outline: none;
            border: 1px solid black;
            appearance: none;
            background: white;
            margin: 10px 0 0 0;
            display: block;
            cursor: pointer;
    }

    .checkbox--input.checkbox--fake {
        width: 24px;
        height: 24px;
        padding: 2px;
        background-color: transparent;
        margin-top: 10px;
        cursor: pointer;

        svg{
            width: 18px;
            height: 18px;

            path{
                fill: $co-green;
            }
        }
    }
</style>
